module.exports = __webpack_public_path__ + "img/hospital-bed-bw-thumb.7e992793.jpg";